import React from 'react';
import './mygameOnBoard.css'
import MediaQuery from 'react-responsive';
import { domain } from '../../common/config.js';
import { onBoardContent } from "./mygameOnBoardContent";
import { saveActivity } from "../../common/commonService";
import { getColor, getImage, getTextColor } from '../../common/ThemeService';

class OnBoard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            accountName: localStorage.getItem('accountName'),
            onBoardID: 1,
            isOnBoard: true
        }
        saveActivity({
            hit_page: 'MyGameOnBoarding',
            hit_type: 'MyGameOnboardingLaunch'
        })
    }

    onClickOnBoard = (onBoardData, value) => {
        let currentId = this.state.onBoardID
        if ((currentId === onBoardContent.length && value != 2) || value === 0) {
            this.setState({ isOnBoard: false })
            if (value === 0)
                saveActivity({
                    hit_page: 'MyGameOnBoarding',
                    hit_type: 'MyGameOnboardingSkip',
                    hit_attribute1: onBoardData.page,
                    hit_attribute2: onBoardData.id,
                })
            this.props.disableOnBoard()

        } else if (value === 1) {
            this.setState({ onBoardID: currentId + 1 })
            saveActivity({
                hit_page: 'MyGameOnBoarding',
                hit_type: 'MyGameOnboardingNext',
                hit_attribute1: onBoardData.page,
                hit_attribute2: onBoardData.id,
            })
        } else if (value === 2) {
            this.setState({ onBoardID: currentId - 1 })
            saveActivity({
                hit_page: 'MyGameOnBoarding',
                hit_type: 'MyGameOnboardingPrev',
                hit_attribute1: onBoardData.page,
                hit_attribute2: onBoardData.id
            })
        }
    }


    render() {
        const themeColor = getColor();
        const themeTextColor = getTextColor();
        let onBoardID = this.state.onBoardID,
            onBoardData = onBoardContent.filter((obj) => obj.id === onBoardID)[0]
        return (
            <div className="onboardMain" >
                <style>{"\
                    .navbar-fixed-top{\
                    z-index:1500 !important;\
                    }\
                "}</style>
                {Object.keys(onBoardData).length > 0 && this.state.isOnBoard &&
                    <div className="onBoardPoistion">
                        <div className='parentMygameOnBoard'>
                            <div className="row mygameOnBoard">
                                <div className="col-sm-4 contentCol">
                                    <div className="mygameOnBoard-header">{onBoardID === 1 && `Hey ${localStorage.getItem('first_name')}! `}<span className="subText">{onBoardData.header}</span></div>
                                    <MediaQuery maxWidth={767} >
                                        <div className="col-sm-4 imgCol">
                                            <center>
                                                <img src={getImage(`//${domain}/images/onBoard/`,`/${onBoardID === 1 ? onBoardData.mobImg : onBoardData.img}.png`)} className={`mygameOnBoard-img ${['MyReport','MyStatsMyHands'].includes(onBoardData.page) && 'paddingZeroImg'}`} alt={`${onBoardData.img}`} style={onBoardData.style} />
                                            </center>
                                        </div>
                                        <div className="col-sm-4 btnCol" >
                                            {Array.from({ length: 5 }, (_, i) => i + 1).map(id =>
                                                <i className={`fa fa-circle onBoardPagination ${onBoardID === id && 'activeOnBoardPagination'}`}
                                                style={ onBoardID === id ? {
                                                    color: themeColor
                                                } : {}}
                                                ></i>
                                            )}
                                        </div>
                                    </MediaQuery>
                                    {(onBoardData.content).split('\n').map((obj, i) =>
                                       obj!=='' && <div className={`mygameOnBoard-subHeader ${i > 0 && 'addPara'}`} key={i}>{obj}</div>)}
                                    <div className={`contentColFooter  ${['MyReport','MyStatsMyHands'].includes(onBoardData.page) && 'contentColFooterPadding'}`}>
                                        <button className="mygameOnBoard-btn" onClick={() => this.onClickOnBoard(onBoardData, 1)}
                                            style={{
                                                backgroundColor: themeColor,
                                                color: themeTextColor,
                                            }}
                                        >{onBoardData.btnText}</button>
                                        {onBoardID == 1 ?
                                            <button className="mygameOnBoard-skip-pre-btn" onClick={() => this.onClickOnBoard(onBoardData, 0)}>SKIP</button>
                                            : <button className="mygameOnBoard-skip-pre-btn" onClick={() => this.onClickOnBoard(onBoardData, 2)}>PREV</button>
                                        }
                                    </div>
                                </div>
                                <MediaQuery minWidth={768} >
                                    <div className="col-sm-4 imgCol">
                                        <center>
                                            <img src={getImage(`//${domain}/images/onBoard/`,`/${onBoardData.img}.png`)} className='mygameOnBoard-img' alt={`${onBoardData.img}`} style={onBoardData.style} />
                                        </center>
                                    </div>
                                </MediaQuery>
                                <MediaQuery minWidth={768} >
                                    <div className="col-sm-4 btnCol">
                                        <center>
                                            {Array.from({ length: 5 }, (_, i) => i + 1).map(id =>
                                                <div> <i className={`fa fa-circle onBoardPagination ${onBoardID === id && 'activeOnBoardPagination'}`}
                                                style={ onBoardID === id ? {
                                                    color: themeColor
                                                } : {}}></i></div>
                                            )}
                                        </center>
                                    </div>
                                </MediaQuery>
                            </div>
                        </div>
                    </div>
                }
            </div >
        )
    }
}

export default OnBoard;


/** WEBPACK FOOTER **
 ** ./src/components/MygameOnBoard/OnBoard.js
 **/